import type {
  GatherTaskDropOff,
  GatherTaskPickup,
  OrderDelivery,
  OrderPickup,
  TaskWithBulkInfo,
  TourTask,
} from "../api/types";

export function isTruthyAndNotEmpty<TItem>(
  item: TItem,
): item is NonNullable<TItem> {
  return !!item;
}

export function isOrderDelivery(tourTask: TourTask): tourTask is OrderDelivery {
  return tourTask.taskType === "order-delivery";
}

export function isOrderPickup(tourTask: TourTask): tourTask is OrderPickup {
  return tourTask.taskType === "order-pickup";
}

export function isGatherTaskPickup(
  tourTask: TourTask,
): tourTask is GatherTaskPickup {
  return tourTask.taskType === "gatherTask-pickup";
}

export function isGatherTaskDropOff(
  tourTask: TourTask,
): tourTask is GatherTaskDropOff {
  return tourTask.taskType === "gatherTask-dropOff";
}

export function isBulkTask(task: TourTask): task is TaskWithBulkInfo {
  return (
    ("bulkGatherTask" in task && task.bulkGatherTask !== undefined) ||
    ("bulkOrder" in task && task.bulkOrder !== undefined)
  );
}
